function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesPocketWifiFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M25.969 7.03A11.969 11.969 0 0130 16c0 3.319-1.348 6.322-3.525 8.494l-1.494-1.338A9.967 9.967 0 0028 16a9.974 9.974 0 00-3.45-7.552L25.97 7.03z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.134 9.865A7.982 7.982 0 0126 16a7.975 7.975 0 01-2.512 5.817l-1.495-1.34A5.984 5.984 0 0024 16a5.987 5.987 0 00-2.29-4.712l1.424-1.423z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.283 12.716a3.995 3.995 0 01.206 6.413l-1.531-1.374a1.999 1.999 0 00-.137-3.577l1.462-1.462zM15 5h2v22h-2V5zM4 5v22h13l-.01.204A2 2 0 0115 29H4a2 2 0 01-2-2V5a2 2 0 012-2h11a2 2 0 011.99 1.796L17 5H4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 19h3v-6H8v6zm5 1l-.005.102a1 1 0 01-.893.893L12 21H7l-.103-.005a1 1 0 01-.892-.893L6 20v-8a1 1 0 011-1h5a1 1 0 011 1v8z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesPocketWifiFilled;